import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { Navigation } from "./components/layout/Navigation";
import { Footer } from "./components/layout/Footer";
import { Toaster } from "./components/ui/sonner";
import PWAInstaller, { OfflineIndicator } from "./components/PWAInstaller";
import { FeedbackBanner } from "./components/FeedbackBanner";

// Pages
import HomePage from "./pages/HomePage";
import LibraryPage from "./pages/LibraryPage";
import ArticlePage from "./pages/ArticlePage";
import ChatPage from "./pages/ChatPage";
import CasePage from "./pages/CasePage";
import LearnPage from "./pages/LearnPage";
import GlossaryPage from "./pages/GlossaryPage";
import SearchPage from "./pages/SearchPage";
import ChangelogPage from "./pages/ChangelogPage";
import OfflinePage from "./pages/OfflinePage";
import FourScalePage from "./pages/FourScalePage";
import RulebookPage from "./pages/RulebookPage";
import FeedbackPage from "./pages/FeedbackPage";
import SimulatePage from "./pages/SimulatePage";
import ComparePage from "./pages/ComparePage";
import GraphPage from "./pages/GraphPage";

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <OfflineIndicator />
          <Navigation />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/library" element={<LibraryPage />} />
              <Route path="/article/:articleNumber" element={<ArticlePage />} />
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/case" element={<CasePage />} />
              <Route path="/learn" element={<LearnPage />} />
              <Route path="/glossary" element={<GlossaryPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/changelog" element={<ChangelogPage />} />
              <Route path="/offline" element={<OfflinePage />} />
              <Route path="/four-scale" element={<FourScalePage />} />
              <Route path="/rulebook" element={<RulebookPage />} />
              <Route path="/feedback" element={<FeedbackPage />} />
              <Route path="/simulate" element={<SimulatePage />} />
              <Route path="/compare" element={<ComparePage />} />
              <Route path="/graph" element={<GraphPage />} />
            </Routes>
          </main>
          <Footer />
          <PWAInstaller />
          <FeedbackBanner />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;
